import React, { useState } from 'react'
import './associates.scss'
import '../search-customer/search-customer.scss'
import Modal from '../../components/common/modal/Modal'
import SinglePage from '../../components/common/page/SinglePage'
import TableFilter from '../../components/common/table-filter/TableFilter'
import { FaPlus } from 'react-icons/fa'
import SpinWithMessage from '../../components/common/spinners/SpinWithMessage'
import CUAssociates from '../../components/user/associates/CUAssociates'
import { customerAxios } from '../../config/axios'
import toast from 'react-hot-toast'
import InfoBox from '../../components/common/info-box/InfoBox'
import NormalInput from '../../components/common/inputs/NormalInput'
import CheckboxInput from '../../components/common/inputs/CheckboxInput'
import { BiLoaderAlt } from 'react-icons/bi'
import { FcDeleteDatabase, FcSearch } from 'react-icons/fc'
import { GrEdit } from "react-icons/gr";
import { GoTrash } from "react-icons/go";
import { PiSpinnerBold } from "react-icons/pi";

const Associates = () => {
  const [modal, setModal] = useState({ status: false })
  const [loading, setLoading] = useState('fetch')
  const [data, setData] = useState([])
  const [form, setForm] = useState({ asot_types: [], key: '' })
  const [ifSearch, setIfSearch] = useState(false)

  const openCUAssociate = () => {
    setModal({
      status: true, title: "Create new associate", width: '600px',
      content: <CUAssociates setModal={setModal} setData={setData} />
    })
  }

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value
    })
  }

  const asotTypeChange = (e) => {

    const asot = form.asot_types.includes(e.target.value)
    if (asot) {
      setForm({
        ...form,
        asot_types: form.asot_types.filter((value) => e.target.value !== value)
      })

    } else {
      setForm({
        ...form,
        asot_types: [...form.asot_types, e.target.value],
      })
    }
  }

  const handleApply = (e) => {
    e.preventDefault();

    if (!form?.key && form?.asot_types?.length < 1) {
      toast.error('Choose any filter options')
      return;
    }

    if (form.key && form.key.length < 3) {
      toast.error('Enter at least 3 characters')
      return;
    }

    setLoading('filter')
    customerAxios.get(`/associate/search?key=${form.key}&asot_types=${form.asot_types}`)
      .then((response) => {
        setIfSearch(true)
        setData(response.data)
        setLoading('')
      }).catch((error) => {
        toast.error(error.message)
        setLoading('')
      })
  }

  const handleDelete = (asotId) => {

    const ask = window.confirm('Are ready for delete ?')

    if (ask) {
      setLoading('delete' + asotId)

      customerAxios.delete(`/associate?asot_id=${asotId}`).then(() => {
        setLoading('')
        setData((state) => state.filter((asot) => asot?.asot_id !== asotId))
      }).catch((error) => {
        toast.error(error.message)
      })
    }

  }



  return (
    <div className="associates-page-div">
      <Modal modal={modal} setModal={setModal} />
      <SinglePage titleArray={['Associates List']}>
        <div className="search-border-div">
          <div className="filter-border-div">
            <button className='add-button' type='button' onClick={() => openCUAssociate()}> <FaPlus /> New Associate</button>
            <form action="" onSubmit={handleApply} style={{ marginTop: '15px' }}>
              <div className="search-section">
                <h5>Search</h5>
                <InfoBox description={'Your can search Name / Title, Address, Place, Contacts '} />
                <NormalInput label='Enter at least 3 characters' name='key' value={form.key} onChangeFun={handleChange} isRequired={false} />
              </div>
              <div className="search-section">
                <h5>Associate type</h5>
                <CheckboxInput label={'Person'} name={'asot_types'} value={'Person'} isRequired={false} onChangeFun={asotTypeChange} />
                <CheckboxInput label={'Non person'} name={'asot_types'} value={'Non person'} isRequired={false} onChangeFun={asotTypeChange} />
                <CheckboxInput label={'Owner'} name={'asot_types'} value={'Owner'} isRequired={false} onChangeFun={asotTypeChange} />
              </div>

              {(form?.key?.length > 2 || form?.asot_types?.length > 0) &&
                <div className="button-div">
                  <button type='submit'>{loading === 'filter' ? <span className='loading-icon'><BiLoaderAlt /></span> : "Filter"}</button>
                </div>}
            </form>
          </div>
          <div className="result-div">
            <div className="header-div">
              {ifSearch ? <h4>{data?.length || '0'} {data?.length > 1 ? 'Results' : 'Result'}</h4>
                : <h4>Find Associate</h4>
              }
              <div className="right-div">
              </div>
            </div>
            <div className="items-div">
              {data?.[0] ?
                <TableFilter>
                  <table className='table'>
                    <thead>
                      <tr>
                        <th>Asot ID</th>
                        <th>Name / Title</th>
                        <th>Asot type</th>
                        <th>Work type / CID / Staff</th>
                        <th>Mobile / Company</th>
                        <th hidden></th>
                        <th>Control</th>
                      </tr>
                    </thead>
                    <tbody>
                      {data?.map((asot) => {
                        return <tr key={asot.asot_id}>
                          <td>{asot.asot_id}</td>
                          <td>{asot.first_name} {asot?.last_name}
                            <br></br>
                            {asot?.address?.address && `${asot?.address?.address}, `} {asot?.address?.place}
                          </td>
                          <td>{asot.asot_type}</td>
                          <td>
                            {asot?.worker_type && `${asot?.worker_type} / ${asot?.worker_sub_type}`}
                            <div className="badge-div">
                              {asot?.staff_id && <div className='badge staff'>Staff Account</div>}
                              {asot?.cid?.[0] && <div className='badge customer'>CID : {asot?.cid?.[0]}</div>}
                            </div>
                          </td>
                          <td>
                            {asot?.primary_number?.number && <>{`PN : ${asot?.primary_number?.number}`} <br></br></>}
                            {asot?.secondary_number?.number && <>{`SN : ${asot?.secondary_number?.number}`} <br></br></>}
                            {asot?.whatsapp_number?.number && <>{`WN : ${asot?.whatsapp_number?.number}`} <br></br></>}
                            {asot?.business?.company_name && `${asot?.business?.company_name}`}
                          </td>
                          <td hidden>
                            {asot?.primary_number?.number}
                            {asot?.secondary_number?.number}
                            {asot?.whatsapp_number?.number}
                            {asot?.cid?.[0]}
                          </td>
                          <td>
                            <div className="button-div">
                              <button onClick={() => setModal({
                                status: true, title: 'Update Associate', width: '600px',
                                content: <CUAssociates currentData={asot} setData={setData} setModal={setModal} />
                              })}><GrEdit /></button>
                              <button onClick={() => handleDelete(asot?.asot_id)}>{loading === `delete${asot?.asot_id}`
                                ? <span className='loading-icon'><PiSpinnerBold /></span> : <GoTrash />}</button>
                            </div>
                          </td>
                        </tr>

                      })}
                    </tbody>
                  </table>
                </TableFilter>
                : <>
                  <SpinWithMessage height={'300px'} spin={false} message={ifSearch ? 'No matched data' : 'Search associate'}
                    icon={ifSearch ? <FcDeleteDatabase /> : <FcSearch />} />
                </>}
            </div>
          </div>
        </div>
      </SinglePage>
    </div>
  )
}

export default Associates